import { ChallengeProvider } from '../context/ChallengeContext';
import { AppShell } from '../components/Layout/AppShell';
import { Header } from '../components/Layout/Header';
import { Container } from '../components/Layout/Container';
import { EventInfo } from '../components/EventInfo/EventInfo';
import { ForgeChallenge } from '../components/Challenges/ForgeChallenge';
import { SideQuests } from '../components/Challenges/SideQuests';
import styles from '../App.module.css';

/**
 * Backup Page - Hidden backup page with key components
 * 
 * Contains:
 * - EventInfo component
 * - ForgeChallenge component
 * - SideQuests component
 */
export function Backup() {
  return (
    <ChallengeProvider>
      <AppShell>
        <div className={styles.app}>
          <Header />
          
          <main className={styles.main}>
            <Container>
              {/* Event Info - Full Width */}
              <section id="info" className={`${styles.section} ${styles.fullWidth}`}>
                <EventInfo />
              </section>

              {/* Challenges Section */}
              <div className={styles.gridLayout}>
                <div className={styles.leftColumn}>
                  <section id="forge" className={styles.section}>
                    <ForgeChallenge />
                  </section>
                </div>

                <div className={styles.rightColumn}>
                  <section id="quests" className={styles.section}>
                    <SideQuests />
                  </section>
                </div>
              </div>
            </Container>
          </main>
        </div>
      </AppShell>
    </ChallengeProvider>
  );
}
